import { render, staticRenderFns } from "./AddToMailinglists.vue?vue&type=template&id=25e91842&"
import script from "./AddToMailinglists.vue?vue&type=script&lang=js&"
export * from "./AddToMailinglists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports